import React, { Component } from 'react';

import styles from './index.module.scss'
import oneLightOneImg from './numLight/oneLight/oneLight-one.jpg'
import oneLightTwoImg from './numLight/oneLight/oneLight-two.jpg'
import oneLightThreeImg from './numLight/oneLight/oneLight-three.jpg'
import oneLightFourImg from './numLight/oneLight/oneLight-four.jpg'
import twoLightOneImg from './numLight/twoLight/twoLight-one.jpg'
import twoLightTwoImg from './numLight/twoLight/twoLight-two.jpg'
import twoLightThreeImg from './numLight/twoLight/twoLight-three.jpg'
import twoLightFourImg from './numLight/twoLight/twoLight-four.jpg'
import threeLightOneImg from './numLight/threeLight/threeLight-one.jpg'
import threeLightTwoImg from './numLight/threeLight/threeLight-two.jpg'
import threeLightThreeImg from './numLight/threeLight/threeLight-three.jpg'
import threeLightFourImg from './numLight/threeLight/threeLight-four.jpg'
import fourLightOneImg from './numLight/fourLight/fourLight-one.jpg'
import fourLightTwoImg from './numLight/fourLight/fourLight-two.jpg'
import fourLightThreeImg from './numLight/fourLight/fourLight-three.jpg'
import fourLightFourImg from './numLight/fourLight/fourLight-four.jpg'

import numLightClickImg from './numLight/num-light-toclick.jpg'
import numLightClickImgCN from './numLight/num-light-toclick-cn.jpg'

class NumLight extends Component {

    state = {
        oneLight: true,
        twoLight: false,
        threeLight: false,
        fourLight: false,
        click: false
      }

      firstClickHandle = () => {
        this.setState({
          click: true
        })
      }

    clickNumHandle = (num) => {
        let numLight = {
          oneLight: false,
          twoLight: false,
          threeLight: false,
          fourLight: false
        }
        if(num === 1){
          numLight = {
            ...numLight,
            oneLight: true,
          }
        }else if(num === 2){
          numLight = {
            ...numLight,
            twoLight: true,
          }
        }else if(num === 3){
          numLight = {
            ...numLight,
            threeLight: true,
          }
        }else if(num === 4){
          numLight = {
            ...numLight,
            fourLight: true,
          }
        }
        this.setState({
          ...numLight
        })
      }

  render() {


    const { oneLight, twoLight, threeLight, fourLight, click } = this.state

    const { language, mobile } = this.props

    const imgStyle = mobile ? styles.mobileImg : styles.img
    const contentImgStyle = mobile ? styles.mobileContentImg : styles.contentImg

    return (
        <div className={styles.numLight}>
          <div style={{display:(oneLight&&!click)?"":"none"}}>
          {'en'===language &&
          <div className={contentImgStyle}>
                <img src={numLightClickImg} className={imgStyle} onClick={this.firstClickHandle} alt=''/>
            </div>
          }
          {'ch'===language &&
          <div className={contentImgStyle}>
                <img src={numLightClickImgCN} className={imgStyle} onClick={this.firstClickHandle} alt=''/>
            </div>
          }
              <div className={styles.contentText}>
                <p align="center" className='lightText'>
                  </p>
              </div>
          </div>
            <div style={{display:(oneLight&&click)?"":"none"}}>
              <div className={contentImgStyle}>
                  <img src={oneLightOneImg} className={styles.numLightImg} alt=''/>
                  <img src={oneLightTwoImg} className={styles.numLightImg} onMouseOver={() => {this.clickNumHandle(2)}} onClick={() => {this.clickNumHandle(2)}} alt=''/>
                  <img src={oneLightThreeImg} className={styles.numLightImg} onMouseOver={() => {this.clickNumHandle(3)}} onClick={() => {this.clickNumHandle(3)}} alt=''/>
                  <img src={oneLightFourImg} className={styles.numLightImg} onMouseOver={() => {this.clickNumHandle(4)}} onClick={() => {this.clickNumHandle(4)}} alt=''/>
              </div>
              {'en'===language &&
              <div className={styles.contentText}>
                <p align="center" className='lightText'>
                  <a href="https://cemoy.com/shop/product/the-lumen-series/lumen-cream/" target="_blank" className="underText">Lumen Cream</a>
                  </p>
              </div>
              }
              {'ch'===language &&
              <div className={styles.contentText}>
                <p align="center" className='lightText'>
                  <a href="https://detail.tmall.com/item.htm?id=609067691879&skuId=4444137894378" target="_blank" className="underText">白金流明面霜</a>
                  </p>
              </div>
              }
            </div>
            <div style={{display:twoLight?"":"none"}}>
              <div className={contentImgStyle}>
                  <img src={twoLightOneImg} className={styles.numLightImg} onMouseOver={() => {this.clickNumHandle(1)}} onClick={() => {this.clickNumHandle(1)}} alt=''/>
                  <img src={twoLightTwoImg} className={styles.numLightImg} alt=''/>
                  <img src={twoLightThreeImg} className={styles.numLightImg} onMouseOver={() => {this.clickNumHandle(3)}} onClick={() => {this.clickNumHandle(3)}} alt=''/>
                  <img src={twoLightFourImg} className={styles.numLightImg} onMouseOver={() => {this.clickNumHandle(4)}} onClick={() => {this.clickNumHandle(4)}} alt=''/>
              </div>
              {'en'===language &&
              <div className={styles.contentText}>
                <p align="center" className='lightText'>
                  <a href="https://cemoy.com/shop/product/the-lumen-series/lumen-toner/" target="_blank" className="underText">Lumen Toner</a>
                </p>
              </div>
              }
              {'ch'===language &&
              <div className={styles.contentText}>
                <p align="center" className='lightText'>
                  <a href="https://detail.tmall.com/item.htm?id=600322856503&skuId=4367325450786" target="_blank" className="underText">白金流明精华水</a>
                </p>
              </div>
              }
            </div>
            <div style={{display:threeLight?"":"none"}}>
              <div className={contentImgStyle}>
                  <img src={threeLightOneImg} className={styles.numLightImg} onMouseOver={() => {this.clickNumHandle(1)}} onClick={() => {this.clickNumHandle(1)}} alt=''/>
                  <img src={threeLightTwoImg} className={styles.numLightImg} onMouseOver={() => {this.clickNumHandle(2)}} onClick={() => {this.clickNumHandle(2)}} alt=''/>
                  <img src={threeLightThreeImg} className={styles.numLightImg} alt=''/>
                  <img src={threeLightFourImg} className={styles.numLightImg} onMouseOver={() => {this.clickNumHandle(4)}} onClick={() => {this.clickNumHandle(4)}} alt=''/>
              </div>
              {'en'===language &&
              <div className={styles.contentText}>
                <p align="center" className='lightText'>
                  <a href="https://cemoy.com/shop/product/the-lumen-series/lumen-lotion/" target="_blank" className="underText">Lumen Lotion</a>
                </p>
              </div>
              }
              {'ch'===language &&
              <div className={styles.contentText}>
                <p align="center" className='lightText'>
                  <a href="https://detail.tmall.com/item.htm?id=600559169009&skuId=4874703967664" target="_blank" className="underText">白金流明精华乳</a>
                </p>
              </div>
              }
            </div>
            <div style={{display:fourLight?"":"none"}}>
              <div className={contentImgStyle}>
                  <img src={fourLightOneImg} className={styles.numLightImg} onMouseOver={() => {this.clickNumHandle(1)}}  onClick={() => {this.clickNumHandle(1)}} alt=''/>
                  <img src={fourLightTwoImg} className={styles.numLightImg} onMouseOver={() => {this.clickNumHandle(2)}} onClick={() => {this.clickNumHandle(2)}} alt=''/>
                  <img src={fourLightThreeImg} className={styles.numLightImg} onMouseOver={() => {this.clickNumHandle(3)}} onClick={() => {this.clickNumHandle(3)}} alt=''/>
                  <img src={fourLightFourImg} className={styles.numLightImg} alt=''/>
              </div>
              {'en'===language &&
              <div className={styles.contentText}>
                <p align="center" className='lightText'>
                  <a href="https://cemoy.com/shop/product/the-lumen-series/lumen-facial-treatment-cleanser/" target="_blank" className="underText">Lumen Facial Treatment Cleanser</a>
                </p>
              </div>
              }
              {'ch'===language &&
              <div className={styles.contentText}>
                <p align="center" className='lightText'>
                  <a href="https://detail.tmall.com/item.htm?id=600328080603&skuId=4697075504738" target="_blank" className="underText">白金流明洁面</a>
                </p>
              </div>
              }
            </div>
        </div>
    );
  }
}

export default NumLight;
